import { Icon } from '@iwoca/orion';

import BusSideSVG from './busSideSVG';
import MetaSVG from './metaSVG';
import NewspaperSVG from './newspaperSVG';
import SpeechSVG from './speechSVG';

export function getIconFromQuestion(answerValue) {
    switch (answerValue) {
        case 'letter':
            return <Icon icon="mailbox" />;
        case 'search_engine':
            return <Icon icon="zoomOutline" />;
        case 'word_of_mouth':
            return <SpeechSVG />;
        case 'in_the_news':
            return <NewspaperSVG />;
        case 'radio':
            return <Icon icon="microphoneOutline" />;
        case 'train_or_bus_ad':
            return <BusSideSVG />;
        case 'social_media':
            return <MetaSVG />;
        case 'other':
            return <Icon icon="plusCircle" />;
        default:
            return null;
    }
}
